import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { ProductCard } from "../components";
import home_1 from "../images/ollivanders-1.jpg";
import home_2 from "../images/ollivanders-2.jpg";
// import home_1 from "../images/home_1.jpeg";
// import home_2 from "../images/home_2.jpeg";
import { useSelector } from "react-redux";

const shopInfo = [
  {
    id: 1,
    image: <i class="fas fa-bolt"></i>,
    title: "Mission",
    body: "Whether it's replica wands, house-themed apparel, home decor, collectibles, or accessories, the Ollivander's aimed to be a one-stop destination for all things magical",
  },
  {
    id: 2,
    image: <i class="fas fa-bolt"></i>,
    title: "Vision",
    body: "Our store strives to transport customers to a realm brimming with extraordinary experiences, captivating treasures, and a sense of awe-inspiring adventure.",
  },
  {
    id: 3,
    image: <i class="fas fa-bolt"></i>,
    title: "History",
    body: "Ollivanders was a wand shop founded in 382 B.C. It was owned by the Ollivander family, widely acknowledged to be the best wandmakers in Great Britain.",
  },
];

const Home = () => {
  const { allProducts } = useSelector((state) => state.products);
  return (
    <Wrapper>
      <section className="hero-section">
        <img className="shop-img" src={home_2} alt="" />
        <div className="content">
          <h2>Welcome to the Wizard World</h2>
          <p>
            Immerse yourself in the spellbinding universe of Wizard World like
            never before with the Ollivander's E-commerce Store. As avid fans of
            the magical saga ourselves, we've created an online emporium where
            witches, wizards, and muggles alike can find an extensive collection
            of authentic wizard merchandise and memorabilia.
          </p>
          <Link to="/products">
            <button className="btn">SHOP NOW</button>
          </Link>
        </div>
        <div className="image">
          <img className="main-img" src={home_1} alt="intro" />
          <div className="background"></div>
          <img className="sec-img" src={home_2} alt="secondary" />
        </div>
      </section>

      <section className="featured-products">
        <h2>Featured Products</h2>
        {!allProducts ? (
          <h3 className="no-products">Error!! No products...</h3>
        ) : (
          <>
            <p></p>
            <div className="products">
              {allProducts.slice(0, 3).map((product, index) => {
                return <ProductCard key={index} {...product} />;
              })}
            </div>
            <Link to="/products">
              <button className="btn">ALL PRODUCTS</button>
            </Link>
          </>
        )}
      </section>

      <section className="shop-info">
        <div className="outer">
          <div className="heading">
            <h2>
              Unique Products <br /> Built Only For You
            </h2>
            <p>
              The wand chooses the wizard. It is not always clear why, but the
              wand has its own way of sensing the innate magic within a witch or
              wizard
            </p>
          </div>
          <div className="info-cards">
            {shopInfo.map(({ id, title, image, body }) => {
              return (
                <div key={id}>
                  <span>{image}</span>
                  <h3>{title}</h3>
                  <p>{body}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section className="newsletter">
        <h2>Join our newsletter and get 20% off</h2>
        <div className="content">
          <p>
            Stay up to date with the latest news and updates by subscribing to
            our newsletter. Don't miss out on exciting announcements and
            exclusive content. Join now!
          </p>
          <form action="#">
            <input type="email" placeholder="Enter email" name="email" />
            <button className="btn" type="submit">
              Subscribe
            </button>
          </form>
        </div>
      </section>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  .hero-section {
    width: 80vw;
    display: flex;
    margin: 50px auto;
    align-items: center;
    .shop-img {
      display: none;
    }
    > .content {
      flex: 1;
      margin-right: 20px;
      h2 {
        /* font-family: var(--font-family-2); */
        font-size: 3em;
        font-weight: 700;
        width: 100%;
        min-width: 250px;
        text-transform: capitalize;
      }
      p {
        margin: 1.5em 0;
        line-height: 2.5;
        text-align: justify;
      }
      button {
        font-size: 1em;
      }
    }
    > .image {
      flex: 1;
      position: relative;

      .main-img {
        display: block;
        margin: auto;
        /* height: 70vh; */
        max-width: 400px;
        height: auto;
        width: 100%;
        border-radius: 10px;
      }
      > .background {
        position: absolute;
        height: 80%;
        width: 50%;
        top: 4rem;
        left: 4rem;
        border-radius: 5px;
        z-index: -1;
        background-color: var(--color-primary-6);
      }
      > .sec-img {
        position: absolute;
        width: 14rem;
        height: auto;
        object-fit: contain;
        border-radius: 5px;
        bottom: 0;
      }
    }
  }

  .featured-products {
    background-color: var(--color-secondary-1);
    padding: 50px 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    .no-products {
      color: var(--color-black-1);
    }
    > h2 {
      font-size: 2.5rem;
    }
    > p {
      width: 7rem;
      height: 0.25rem;
      background-color: var(--color-primary-1);
    }
    > .products {
      margin: 3rem auto;
      /* max-width: 1000px; */
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
      > div {
        margin: 1rem;
      }
    }
  }

  .shop-info {
    padding: 0 10vw;
    background-color: var(--color-primary-2);

    .outer {
      transform: translateY(5rem);
      > .heading {
        margin-bottom: 4rem;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        > h2 {
          flex: 1;
          font-size: 2rem;
          font-weight: 700;
          color: var(--color-primary-4);
          margin-right: 20px;
          min-width: 250px;
        }
        > p {
          flex: 1;
          text-align: justify;
          color: var(--color-primary-3);
          min-width: 250px;
        }
      }
      .info-cards {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
        gap: 2rem;
        > div {
          display: flex;
          flex-direction: column;
          align-items: center;
          background-color: var(--color-primary-5);
          text-align: center;
          padding: 2.5rem 2rem;
          border-radius: 5px;
          > span {
            color: var(--color-primary-4);
            font-size: 1.5rem;
            width: 4rem;
            height: 4rem;
            background-color: var(--color-primary-2);
            display: grid;
            place-content: center;
            border-radius: 50%;
          }
          > h3 {
            font-size: 1.5rem;
            color: var(--color-primary-4);
            margin: 1rem 0;
          }
          > p {
            line-height: 2;
          }
        }
      }
    }
  }

  .newsletter {
    padding: 15% 10vw;
    h2 {
      font-size: 2rem;
      margin-bottom: 4rem;
    }
    .content {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
      gap: 2rem;
      text-align: justify;
      form {
        display: flex;
        border: 2px solid var(--color-black-1);
        border-radius: 5px;
        overflow: hidden;
        input {
          width: 80%;
          border: none;
          padding: 0 1rem;
        }
        button {
          width: 20%;
          min-width: 100px;
          border-radius: 0;
          box-shadow: none;
        }
      }
    }
  }

  @media screen and (max-width: 810px) {
    .shop-info > .outer > .heading > p {
      margin-top: 10px;
    }
    .hero-section {
      flex-direction: column;
      .shop-img {
        display: block;
        width: 80vw;
        height: auto;
        object-fit: cover;
        border-radius: 5px;
        margin-bottom: 20px;
      }
      .image {
        display: none;
      }
    }
  }

  @media screen and (max-width: 1200px) {
    .hero-section {
      .sec-img,
      .background {
        display: none;
      }
    }
  }
  @media screen and (max-width: 1500px) {
    .shop-info {
      padding: 5% 10vw;
      .outer {
        transform: none;
      }
    }
  }
`;

export default Home;
